import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import clsx from "clsx";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    rootVertical: {
        flexDirection: 'column',
        width: 'auto',
        marginLeft: props => props.noHorizontalMargin ? 0 : theme.spacing(2),
        marginRight: props => props.noHorizontalMargin ? 0: theme.spacing(2),
        marginTop: 0,
        marginBottom: 0
    },
    lineDiv: {
        flexGrow: 1,
        borderBottom: props => '1px solid ' + (!!props.lineColor ? props.lineColor : theme.palette.secondary.main)
    },
    lineVerticalDiv: {
        minHeight: theme.spacing(2),
        borderRight: props => '1px solid ' + (!!props.lineColor ? props.lineColor : theme.palette.secondary.main),
        '&:first-child': {
            marginBottom: theme.spacing()
        },
        '&:last-child': {
            marginTop: theme.spacing()
        }
    },
    span: {
        color: theme.palette.secondary.main,
        display: 'block',
        marginRight: theme.spacing(),
        marginLeft: theme.spacing()
    }
}));

export default function Separator(props) {
    const {
        orientation = 'horizontal',
        text = 'ou',
        noCenterText = false,
        noHorizontalMargin = false,
        lineColor
    } = props;

    const classes = useStyles({noHorizontalMargin, lineColor});

    return (
        <div className={clsx(classes.root, orientation === 'vertical' && classes.rootVertical)}>
            <div className={clsx(classes.lineDiv, orientation === 'vertical' && classes.lineVerticalDiv)} />
            {!noCenterText && (
                <>
                    <span className={classes.span}>{text}</span>
                    <div className={clsx(classes.lineDiv, orientation === 'vertical' && classes.lineVerticalDiv)} />
                </>
            )}
        </div>
    );
};

Separator.propTypes = {
    orientation: PropTypes.string,
    text: PropTypes.string,
    noCenterText: PropTypes.bool,
    noHorizontalMargin: PropTypes.bool,
    lineColor: PropTypes.string
};